import { render, staticRenderFns } from "./ExposureView.vue?vue&type=template&id=37c2711f&scoped=true"
import script from "./ExposureView.vue?vue&type=script&lang=js"
export * from "./ExposureView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c2711f",
  null
  
)

export default component.exports